module.exports = __webpack_public_path__ + "img/home__1fkc——vi.3f71d367.png";